
/**
 * Modify list of orders and reduce the api bloat
 * @param {Array} list
 */
export function fixOrderList(list) {
  list.forEach((order) => {
    //reduce the bloat but don't produce too much overhead
    //HACK: for ease we reduce the state to something useful
    order.status = order.status.code
    order.order_label = order.order_label.label
    delete order.store
  })

}